import { z } from 'zod'

export const disablePriceSurveySchema = z.object({
  disable_reason: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
})

export type DisablePriceSurveyValidationSchema = z.infer<typeof disablePriceSurveySchema>
